import { firestore } from 'firebase';

export class News {
    id: string;
    text: string;
    timestamp?: firestore.Timestamp;
}